var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(this.$root.showBg)?_c('img',{staticClass:"backrgound",attrs:{"src":require("./assets/roleList/bg_dark@2x.png")}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }